import { Box, xcss } from '@atlaskit/primitives';
import React from 'react';

const TagStyles = xcss({
  backgroundColor: 'color.background.neutral',
  color: 'color.text',
  borderRadius: 'radius.small',
  paddingInline: 'space.050',
  paddingBlock: 'space.025',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
});

const Tag = ({ text }: { text: string }) => {
  return (
    <Box xcss={TagStyles} as="span" key={text}>
      {text}
    </Box>
  );
};

export default Tag;
